// extracted by mini-css-extract-plugin
export default {"meal":"MealTtem_meal__2rZj3","description":"MealTtem_description__VYsK-","price":"MealTtem_price__GrMCQ"};